Drupal.behaviors.sw_section_testimonials_custom = {
  attach: function( context, settings ) {

    $('.testimonials-custom').once('sw_section_testimonials_custom').each(function() {
      let $wrap = $(this);
      let $slider = $wrap.find('.testimonials-custom__slider');
      $slider.slick({
        arrows: true,
        fade: false,
        dots: false,
        adaptiveHeight: false,
        infinite: true,
        centerMode: true,
        //slidesToShow: 1,
        waitForAnimate: false,
      });

    });

  }
};
